import React from 'react';
import { CustomerWillInfo } from 'service/dto/customer.dto';
import BankAssets from './BankAssets';
import BenefitAssets from './BenefitAssets';
import BondAssets from './BondAssets';
import PensionAssets from './PensionAssets';
import PhysicalAssets from './PhysicalAssets';
import StockAssets from './StockAssets';
import SpouseList from './SpouseList';
import ChildrenList from './ChildrenList';
import { UserInfoDto } from 'service/dto/user.dto';
import GuardianList from './GuardianList';
import ExecustorList from './ExecutorList';
import TrusteeList from './TrusteeList';

type IProps = {
  assets: CustomerWillInfo | undefined;
  user: UserInfoDto | undefined;
};

export default function UserAssets({ assets, user }: IProps) {
  return (
    <div>
      {assets?.spouses && <SpouseList items={assets?.spouses} user={user} />}
      {assets?.children && (
        <ChildrenList items={assets?.children} user={user} />
      )}
      {assets?.guardians && (
        <GuardianList items={assets?.guardians} user={user} />
      )}
      {assets?.executors && (
        <ExecustorList items={assets?.executors} user={user} />
      )}
      {assets?.trustees && <TrusteeList items={assets?.trustees} user={user} />}
      {assets?.bonds && <BankAssets assets={assets?.banks} />}
      {assets?.employerBenefits && (
        <BenefitAssets assets={assets?.employerBenefits} />
      )}
      {assets?.bonds && <BondAssets assets={assets?.bonds} />}
      {assets?.pensions && <PensionAssets assets={assets?.pensions} />}
      {assets?.physicals && <PhysicalAssets assets={assets?.physicals} />}
      {assets?.stocks && <StockAssets assets={assets?.stocks} />}
    </div>
  );
}
